import React from 'react';
import PropTypes from 'prop-types';
import { OptionSelector } from 'components';

const SocialButtonStyle = ({ onChange, value }) => {
  const values = [
    { value: 'small', label: 'small' },
    { value: 'big', label: 'big' }
  ];

  return (
    <li className="line-row">
      <span>
        socialButtonStyle:
        <OptionSelector
          name="socialButtonStyle"
          onChange={onChange}
          options={values}
          value={value}
        />
      </span>
    </li>
  );
};

SocialButtonStyle.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired
};

export default SocialButtonStyle;



// WEBPACK FOOTER //
// ./src/components/EditorOption/SocialButtonStyle.js


// WEBPACK FOOTER //
// webpack:///src/components/EditorOption/SocialButtonStyle.js